<template lang="pug">
  v-container#police-report(fluid)
    changeDialog(ref="changeModal" v-bind:data="confiramtionData")
    .d-flex
      .dark-text.bold.py-5 {{ `${policeReportFolio}. Denuncia` }}
      .ml-4.underline.text-danger.py-5.small(@click="deleteReport") Borrar
    v-row(justify="space-between")
      v-col(d-flex xs=6 sm=6)
        v-row.py-1
          label.custom.mb-2 Fecha en que se interpuso la denuncia
        v-row.py-1.select-date
          v-col(d-flex xs=2 sm=2)
            v-select(
              label="Día"
            	:items="days"
            	v-model="reportDateDay"
            )
          v-col(d-flex xs=2 sm=2)
            v-select(
              label="Mes"
              :items="months"
              v-model="reportDateMonth"
            )
          v-col(d-flex xs=3 sm=3)
            v-autocomplete(
              label="Año"
            	:items="years"
            	v-model="reportDateYear"
            )
      v-col(d-flex xs=6 sm=6)
        v-row.py-1
          label.custom.mb-2 ¿Se tomarán muestras de ADN?
        v-row
          v-col.align-radios(d-flex xs=12 sm=12)
            v-radio-group(v-model="confirmADN" row hide-details)
              v-radio(
              	v-for="(confirmAdnOpt, i) in indirectAnswers"
              	:key="`confirmAdnOpt${i}`"
              	:value="i"
              	:label="confirmAdnOpt.name"
              )

    v-row(justify="space-between")
      v-col(d-flex xs=12 sm=12)
       v-expansion-panels.mb-5(flat hover accordion v-if="userPermissions.createOption")
        v-expansion-panel.mr-5
          v-expansion-panel-header
            v-col(xs=12 sm=12)
              v-card(flat)
                p.small.bold.pl-2 Gestionar lugares de denuncia
          v-expansion-panel-content
            v-row
              v-col(xs=12 sm=4)
                v-row.tag-list.mt-4
                  v-col.tag.py-2(xs=12 sm=12 v-if="!reportPlaceCatalogOptions.length > 0")
                    p.field-title.small.mb-0.ml-1 Aún no hay lugares de denuncia registrados
                  v-col.tag.py-2(xs=12 sm=12 v-if="reportPlaceCatalogOptions.length > 0" v-for="(reportPlaceOption, index) in reportPlaceCatalogOptions" :key="index" @click="selectCatalogOption(reportPlaceOption, 'reportPlace')" :class="{ 'toggle-tag': reportPlaceOption.clicked }")
                    p.field-title.small.mb-0.ml-1 {{reportPlaceOption.name}}
                v-row.new-tag.mt-2
                  v-btn.main-background.save.bolder(@click="addCatalogOptions('reportPlace')") Nuevo lugar de denuncia
              v-col.px-5(xs=12 sm=7 v-if="selectedReportPlace")
                label.custom.bold.px-3 {{editingReportPlace ? 'Editar lugar de denuncia' : 'Nuevo lugar de denuncia'}}
                v-text-field.px-3(
                  v-model="selectedReportPlace.name"
                  hide-details
                  class="input-group--focused"
                )
                v-row.justify-end.mt-4
                  v-btn.main-background.save.bolder.smaller.mx-3(@click="updateCatalogOptions('reportPlace')" v-if="editingReportPlace") Guardar cambios
                  v-btn.main-background.save.bolder.smaller.mx-3(@click="newCatalogOptions('reportPlace')" v-else) Guardar lugar de denuncia
                  v-btn.white-btn.save.bolder.smaller(v-if="editingReportPlace" @click="deleteCatalogOptions('reportPlace')") Eliminar lugar de denuncia
                  v-btn.white-btn.save.bolder.smaller(v-else @click="cancelNewCatalogOptions()") Cancelar

      v-col(d-flex xs=12 sm=5)
        v-card.pt-4(flat)
          label.custom.bold Lugar de denuncia
          v-card-title.pa-0.searchbar
            v-select(
              v-model="reportPlace"
              :items="reportPlaceCatalogOptions"
              item-text="name"
              return-object
              @change="sortReportPlaceCatalogOptions"
            )

      v-col(d-flex xs=6 sm=6)
        v-row.py-1
          label.custom.mb-2 ¿Se solicitará fotografía?
        v-row
          v-col.align-radios(d-flex xs=12 sm=12)
            v-radio-group(v-model="confirmPicture" row hide-details)
              v-radio(
              	v-for="(confirmPictureOpt, i) in indirectAnswers"
              	:key="`confirmPictureOpt${i}`"
              	:value="i"
              	:label="confirmPictureOpt.name"
              )
    v-row.pt-1.pb-5
      v-col.pr-2(d-flex xs=12 sm=5)
        v-text-field(
        	v-model="reportPlaceDetails"
          label="Observaciones sobre el lugar de denuncia"
        )


    v-row.pt-1.pb-5
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Se le pidió que pasara un plazo determinado para recibir la denuncia?
        v-row
          v-col.align-radios.pr-0(d-flex xs=5 sm=5)
            v-radio-group(v-model="askForTerm" row hide-details @change="clearDetails($event,'termDetails')")
              v-radio(
              	v-for="(askForTermOpt, i) in indirectAnswers"
              	:key="`askForTermOpt${i}`"
              	:value="i"
              	:label="askForTermOpt.name"
              )
          v-col.side-label.pr-0(d-flex flex xs=5 sm=5)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="termDetails"
              :disabled = "!!askForTerm"
            	v-model="termDetails"
            	hide-details
            )
      v-col(d-flex xs=12 sm=5)
        v-text-field(
        	v-model="otherAuthority"
          label="¿Qué otra autoridad conoce de esta denuncia?"
        )

    v-row.pt-1.pb-5(justify="space-between")
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Existe un número de carpeta o reporte?
        v-row
          v-col.align-radios.pr-0(d-flex xs=5 sm=5)
            v-radio-group(v-model="reportNumConfirm" row hide-details @change="clearDetails($event,'reportNumDetails')")
              v-radio(
              	v-for="(reportNumConfirmOpt, i) in indirectAnswers"
              	:key="`reportNumConfirmOpt${i}`"
              	:value="i"
              	:label="reportNumConfirmOpt.name"
              )
          v-col.side-label.pr-0(d-flex flex xs=5 sm=5)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="reportNumDetails"
              :disabled = "!!reportNumConfirm"
            	v-model="reportNumDetails"
            	hide-details
            )
      v-col.pr-2(d-flex xs=12 sm=6)
        v-row
          label.custom.mb-2 ¿Tiene información adicional que ha surgido en la búsqueda?
        v-row
          v-col.align-radios.pr-0(d-flex xs=4 sm=3)
            v-radio-group(v-model="moreInfoConfirm" row hide-details @change="clearDetails($event,'moreInfoDetails')")
              v-radio(
              	v-for="(moreInfoConfirmOpt, i) in directAnswers"
              	:key="`moreInfoConfirmOpt${i}`"
              	:value="i"
              	:label="moreInfoConfirmOpt.name"
              )
          v-col.side-label.pr-0(d-flex flex xs=6 sm=7)
            label.custom-secondary.pr-3 Especificar
            v-text-field.pt-0(
              ref="moreInfoDetails"
              :disabled = "!!moreInfoConfirm"
            	v-model="moreInfoDetails"
            	hide-details
            )

    v-row.pt-1.pb-5(justify="space-between")
      v-col(d-flex xs=12 sm=12)
       v-expansion-panels.mb-5(flat hover accordion v-if="userPermissions.createOption")
        v-expansion-panel.mr-5
          v-expansion-panel-header
            v-col(xs=12 sm=12)
              v-card(flat)
                p.small.bold.pl-2 Gestionar unidades de denuncia
          v-expansion-panel-content
            v-row
              v-col(xs=12 sm=4)
                v-row.tag-list.mt-4
                  v-col.tag.py-2(xs=12 sm=12 v-if="!authorityCatalogOptions.length > 0")
                    p.field-title.small.mb-0.ml-1 Aún no hay unidades de denuncia registrados
                  v-col.tag.py-2(xs=12 sm=12 v-if="authorityCatalogOptions.length > 0" v-for="(authorityOption, index) in authorityCatalogOptions" :key="index" @click="selectCatalogOption(authorityOption, 'authority')" :class="{ 'toggle-tag': authorityOption.clicked }")
                    p.field-title.small.mb-0.ml-1 {{authorityOption.name}}
                v-row.new-tag.mt-2
                  v-btn.main-background.save.bolder(@click="addCatalogOptions('authority')") Nueva unidad de denuncia
              v-col.px-5(xs=12 sm=7 v-if="selectedAuthority")
                label.custom.bold.px-3 {{editingAuthority ? 'Editar unidad de denuncia' : 'Nueva unidad de denuncia'}}
                v-text-field.px-3(
                  v-model="selectedAuthority.name"
                  hide-details
                  class="input-group--focused"
                )
                v-row.justify-end.mt-4
                  v-btn.main-background.save.bolder.smaller.mx-3(@click="updateCatalogOptions('authority')" v-if="editingAuthority") Guardar cambios
                  v-btn.main-background.save.bolder.smaller.mx-3(@click="newCatalogOptions('authority')" v-else) Guardar lugar de denuncia
                  v-btn.white-btn.save.bolder.smaller(v-if="editingAuthority" @click="deleteCatalogOptions('authority')") Eliminar lugar de denuncia
                  v-btn.white-btn.save.bolder.smaller(v-else @click="cancelNewCatalogOptions()") Cancelar

      v-col(d-flex xs=12 sm=5)
        v-card.pt-4(flat)
          label.custom.bold Unidad en la que está la denuncia
          v-card-title.pa-0.searchbar
            v-select(
              v-model="appealedAuthority"
              :items="authorityCatalogOptions"
              item-text="name"
              return-object
              @change="sortAuthorityCatalogOptions"
            )


      //v-col.upload(v-if="record.folio" d-flex sm=6 xs=12)
        .d-flex.align-items-center(v-for="(file, index) in files" :key="index + 'file'")
          p {{ file.name }}
          v-icon.close.ml-2(@click="deleteFile(index)") clear
        .d-flex.align-items-center(v-for="(file, index) in fileList" :key="index")
          p {{ file.name }}
          v-icon.close.ml-2(@click="removeFile(index)") clear

        p.pick.bold.underline(@click="pickFile") Cargar documentos
          span.ml-2
            font-awesome-icon(icon="upload" size="lg")
        input(
          type="file"
          style="display: none"
          ref="files"
          accept="*"
          @change="saveTmpFile"
        )

</template>

<script>
import ChangeDialog from "@/components/Form/ChangeDialog.vue";

export default {
  name: "PoliceReports",
  props: {
    index: Number,
    report: Object // or any other constructor
  },
  components: {
    ChangeDialog
  },
  data() {
    return {
      searchPlace: null,
      searchAuthority: null,
      editing: null,
      placeIndex: -1,
      fileList: [],
      confiramtionData: {},
      selectedReportPlace: undefined,
      editingReportPlace: false,
      selectedAuthority: undefined,
      editingAuthority: false
    };
  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    record() {
      return this.$store.getters.record;
    },
    policeReportFolio() {
      return this.report.folio + 1;
    },
    days() {
      return this.$store.state.days;
    },
    months() {
      return this.$store.state.months;
    },
    years() {
      return this.$store.state.years;
    },
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    indirectAnswers() {
      return this.$store.state.indirectAnswers;
    },
    reportDateDay: {
      get() {
        return this.report.reportDate.day;
      },
      set(value) {
        this.report.reportDate.day = value;
      }
    },
    reportDateMonth: {
      get() {
        return this.report.reportDate.month;
      },
      set(value) {
        this.report.reportDate.month = value;
      }
    },
    reportDateYear: {
      get() {
        return this.report.reportDate.year;
      },
      set(value) {
        this.report.reportDate.year = value;
      }
    },
    confirmADN: {
      get() {
        return this.indirectAnswers.findIndex(
          indirectAnswer => indirectAnswer.slug == this.report.confirmADN.slug
        );
      },
      set(index) {
        this.report.confirmADN = this.indirectAnswers[index];
      }
    },
    reportPlace: {
      get() {
        return this.report.reportPlace;
      },
      set(value) {
        this.report.reportPlace = value;
      }
    },
    reportPlaceDetails: {
      get() {
        return this.report.reportPlaceDetails;
      },
      set(value) {
        this.report.reportPlaceDetails = value;
      }
    },
    confirmPicture: {
      get() {
        return this.indirectAnswers.findIndex(
          indirectAnswer =>
            indirectAnswer.slug == this.report.confirmPicture.slug
        );
      },
      set(index) {
        this.report.confirmPicture = this.indirectAnswers[index];
      }
    },
    askForTerm: {
      get() {
        return this.indirectAnswers.findIndex(
          indirectAnswer => indirectAnswer.slug == this.report.askForTerm.slug
        );
      },
      set(index) {
        this.report.askForTerm = this.indirectAnswers[index];
      }
    },
    termDetails: {
      get() {
        return this.report.termDetails;
      },
      set(value) {
        this.report.termDetails = value;
      }
    },
    reportNumConfirm: {
      get() {
        return this.indirectAnswers.findIndex(
          indirectAnswer =>
            indirectAnswer.slug == this.report.reportNumConfirm.slug
        );
      },
      set(index) {
        this.report.reportNumConfirm = this.indirectAnswers[index];
      }
    },
    reportNumDetails: {
      get() {
        return this.report.reportNumberDetails;
      },
      set(value) {
        this.report.reportNumberDetails = value;
      }
    },
    otherAuthority: {
      get() {
        return this.report.otherAuthority;
      },
      set(value) {
        this.report.otherAuthority = value;
      }
    },
    moreInfoConfirm: {
      get() {
        return this.directAnswers.findIndex(
          directAnswer => directAnswer.slug == this.report.moreInfoConfirm.slug
        );
      },
      set(index) {
        this.report.moreInfoConfirm = this.directAnswers[index];
      }
    },
    moreInfoDetails: {
      get() {
        return this.report.moreInfoDetails;
      },
      set(value) {
        this.report.moreInfoDetails = value;
      }
    },
    appealedAuthority: {
      get() {
        return this.report.appealedAuthority;
      },
      set(value) {
        this.report.appealedAuthority = value;
      }
    },
    optionToCreate: {
      get() {
        return this.$store.state.optionToCreate;
      },
      set(value) {
        this.$store.state.optionToCreate = value;
      }
    },
    files: {
      get() {
        return this.report.files;
      },
      set(value) {
        this.report.files = value;
      }
    },
    reportPlaceCatalogOptions() {
      return this.$store.state.reportCatalogOptions.filter(
        option => option.field == "reportPlace"
      );
    },
    authorityCatalogOptions() {
      return this.$store.state.reportCatalogOptions.filter(
        option => option.field == "authority"
      );
    }
  },
  watch: {
    reportPlace(val) {
      this.reportPlace = val;
    },
    appealedAuthority(val) {
      this.appealedAuthority = val;
    }
  },
  methods: {
    clearDetails(value, reference) {
      if (!value) {
        this.$refs[reference].internalValue = "";
      }
    },
    // ReportPlace
    // Click in list
    selectCatalogOption(selected, field) {
      this.$store.state.reportCatalogOptions.forEach(
        el => (el.clicked = false)
      );
      this.editingReportPlace = false;
      this.editingAuthority = false;
      this.selectedReportPlace = undefined;
      this.selectedAuthority = undefined;

      if (field == "reportPlace") {
        this.selectedReportPlace = Object.assign({}, selected);
        this.editingReportPlace = true;
      } else if (field == "authority") {
        this.selectedAuthority = Object.assign({}, selected);
        this.editingAuthority = true;
      }
      selected.clicked = true;
    },
    // Create empty entry
    addCatalogOptions(field) {
      this.$store.state.reportCatalogOptions.forEach(
        el => (el.clicked = false)
      );
      this.editingReportPlace = false;
      this.editingAuthority = false;
      if (field == "reportPlace") {
        this.selectedReportPlace = { field: "reportPlace", name: "" };
      } else if (field == "authority") {
        this.selectedAuthority = { field: "authority", name: "" };
      }
    },
    // Save and update list
    async newCatalogOptions(field) {
      try {
        var newEntry = {};
        if (field == "reportPlace") {
          newEntry = this.selectedReportPlace;
        } else if (field == "authority") {
          newEntry = this.selectedAuthority;
        }
        await this.$store.dispatch("createCatalogOption", newEntry);
      } catch (error) {
        console.log(error, "error");
      }
      this.getCatalogOptions();
      this.cancelNewCatalogOptions();
    },
    async updateCatalogOptions(field) {
      var updateEntry = {};
      if (field == "reportPlace") {
        this.confiramtionData = {
          action: "actualizar",
          entity: "lugar de denuncia",
          entityGenre: "m"
        };
        updateEntry = this.selectedReportPlace;
      } else if (field == "authority") {
        this.confiramtionData = {
          action: "actualizar",
          entity: "unidad de denuncia",
          entityGenre: "f"
        };
        updateEntry = this.selectedAuthority;
      }

      if (await this.$refs.changeModal.pop()) {
        try {
          let response = await this.$store.dispatch(
            "updateCatalogOption",
            updateEntry
          );

          if (response.status == 200) {
            // if user modify policeReports we might have outdated data
            //(eg. user add policeReport and set reportPlace to X then he edits X to be named Y this.record is outdated)
            let syncReport = await this.$store.dispatch(
              "getSingleReport",
              this.record._id
            );
            var i = 0;
            for (
              ;
              i < syncReport.data.result[0].narrative.policeReports.length;
              i++
            ) {
              // If user delete a policeReport we are cool, we dont push it from database
              if (this.record.narrative.policeReports[i] != undefined) {
                this.record.narrative.policeReports[i].reportPlace =
                  syncReport.data.result[0].narrative.policeReports[
                    i
                  ].reportPlace;
                this.record.narrative.policeReports[i].appealedAuthority =
                  syncReport.data.result[0].narrative.policeReports[
                    i
                  ].appealedAuthority;
              }
            }
            // if user added policeReports we are not cool, because we dont know if the reportPlaces and appealedAuthorities are updated so we blank them
            //(so the user has to re-enter it and we are 100% sure data is updated)
            if (this.record.narrative.policeReports.length > i) {
              for (; i < this.record.narrative.policeReports.length; i++) {
                this.record.narrative.policeReports[i].reportPlace = "";
                this.record.narrative.policeReports[i].appealedAuthority = "";
              }
            }
          }
        } catch (error) {
          console.log(error, "error");
        }
        this.getCatalogOptions();
      }
      this.cancelNewCatalogOptions();
    },
    cancelNewCatalogOptions() {
      this.$store.state.reportCatalogOptions.forEach(
        el => (el.clicked = false)
      );
      this.editingReportPlace = false;
      this.editingAuthority = false;
      this.selectedReportPlace = undefined;
      this.selectedAuthority = undefined;
    },
    async deleteCatalogOptions(field) {
      var deleteEntry = {};
      if (field == "reportPlace") {
        this.confiramtionData = {
          action: "eliminar",
          entity: "lugar de denuncia",
          entityGenre: "m"
        };
        deleteEntry = this.selectedReportPlace;
      } else if (field == "authority") {
        this.confiramtionData = {
          action: "eliminar",
          entity: "unidad de denuncia",
          entityGenre: "f"
        };
        deleteEntry = this.selectedAuthority;
      }
      if (await this.$refs.changeModal.pop()) {
        try {
          let response = await this.$store.dispatch(
            "deleteCatalogOption",
            deleteEntry
          );

          // Request and update whole store
          if (response.status == 200) {
            // if user modify policeReports we might have outdated data
            //(eg. user add policeReport and set reportPlace to X then he edits X to be named Y this.record is outdated)
            let syncReport = await this.$store.dispatch(
              "getSingleReport",
              this.record._id
            );
            var i = 0;
            for (
              ;
              i < syncReport.data.result[0].narrative.policeReports.length;
              i++
            ) {
              // If user delete a policeReport we are cool, we dont push it from database
              if (this.record.narrative.policeReports[i] != undefined) {
                this.record.narrative.policeReports[i].reportPlace =
                  syncReport.data.result[0].narrative.policeReports[
                    i
                  ].reportPlace;
                this.record.narrative.policeReports[i].appealedAuthority =
                  syncReport.data.result[0].narrative.policeReports[
                    i
                  ].appealedAuthority;
              }
            }
            // if user added policeReports we are not cool, because we dont know if the reportPlaces and appealedAuthorities are updated so we blank them
            //(so the user has to re-enter it and we are 100% sure data is updated)
            if (this.record.narrative.policeReports.length > i) {
              for (; i < this.record.narrative.policeReports.length; i++) {
                this.record.narrative.policeReports[i].reportPlace = "";
                this.record.narrative.policeReports[i].appealedAuthority = "";
              }
            }
          }
        } catch (error) {
          console.log(error, "error");
        }
        this.getCatalogOptions();
      }
      this.cancelNewCatalogOptions();
    },
    sortReportPlaceCatalogOptions() {
      this.reportPlaceCatalogOptions.sort();
    },
    getCatalogOptions() {
      this.$store.dispatch("getCatalogOptions");
    },
    sortAuthorityCatalogOptions() {
      this.authorityCatalogOptions.sort();
    },
    pickFile() {
      this.$refs.files.click();
    },
    removeFile(index) {
      this.report.formData.delete("file[]");
      this.fileList.splice(index, 1);
      this.fileList.forEach(f => {
        this.report.formData.append("file[]", f, f.name);
      });
    },
    async deleteFile(index) {
      const params = {
        file: this.files[index],
        folio: this.record.folio
      };
      let deleted = await this.$store.dispatch("deleteFile", params);
      if (deleted.status == 200) this.files.splice(index, 1);
    },
    async saveTmpFile(e) {
      let file = e.target.files[0];

      if (this.record.folio) {
        this.report.formData.set("file[]", file, file.name);
        try {
          this.$store.commit("setIsLoadingState", true);
          console.log(this.report.formData);
          let uploadFileResponse = await this.$store.dispatch(
            "uploadFile",
            this.report.formData
          );
          this.$store.state.record.narrative.policeReports =
            uploadFileResponse.data.result;
          setTimeout(() => {
            this.report.formData = new FormData();
            this.report.formData.set("folio", this.record.folio);
            this.report.formData.set("index", this.index + 1);
          }, 500);
          this.$store.commit("setShowNotification", {
            type: "success",
            title: "ARCHIVO GUARDADO CON ÉXITO",
            text: uploadFileResponse.message
          });
          this.$store.commit("setIsLoadingState", false);
          this.fileList = [];
        } catch (err) {
          this.$store.commit("setShowNotification", {
            type: "error",
            title: "ERROR",
            text: "ERROR AL CARGAR DOCUMENTO"
          });
          this.$store.commit("setIsLoadingState", false);
        }
      } else {
        this.report.formData.append("file[]", file, file.name);
        this.fileList = this.report.formData.getAll("file[]");
      }
    },
    deleteReport() {
      this.$store.state.record.narrative.policeReports.splice(this.index, 1);
    }
  },
  async mounted() {
    this.report.formData = new FormData();
    this.report.formData.set("folio", this.record.folio);
    this.report.formData.set("index", this.index + 1);
    this.getCatalogOptions();
  }
};
</script>

<style scoped lang="scss">
.col {
  padding-top: 0px;
  padding-bottom: 0px;
  padding-left: 0px;
}

.select-date .v-select {
  padding-top: 0px !important;
}

.align-radios {
  align-self: flex-end;
}

.upload {
  align-self: center;
  p {
    font-size: 0.8rem !important;
  }
  .close {
    font-size: 1rem;
    &:hover {
      opacity: 0.7;
      cursor: pointer;
    }
  }
  p.pick:hover {
    opacity: 0.7;
    cursor: pointer;
  }
}

.text-danger {
  color: red !important;
  cursor: pointer;
}
.tag-list {
  max-height: 300px;
  overflow-y: scroll;
  //border-right: 1px solid #949494;
  .tag.toggle-tag,
  .tag.toggle-tag:hover {
    background-color: rgba(114, 40, 123, 0.25);
  }
  .tag {
    cursor: pointer;
    //overflow: hidden;
    text-overflow: ellipsis;
    padding: 8px 17px;
    &:hover {
      background-color: $main-color-light;
    }
  }
}
</style>
